import { render, staticRenderFns } from "./DriverPriceTable.vue?vue&type=template&id=5509af15&"
import script from "./DriverPriceTable.vue?vue&type=script&lang=js&"
export * from "./DriverPriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports